import React, { useState } from 'react'
import { Edit } from 'lucide-react'
import CustomModal from '../../ui/CustomModal'
import { useTranslation } from 'react-i18next'
import { formatNumber, formatPhoneNumber } from '../../../utils/formatNumber'
import { Owner } from '../../../types/modules/admin/Owner'
import { Link } from 'react-router-dom'
import UpdateOwnerFormByAdmin from './UpdateOwnerFormByAdmin'
import { PermissionGate } from '../PermissionGate'
import { PermissionsKey } from '../../../data/permissions'

type Props ={
    owner:Owner
}

function OwnerItem({owner}:Props) {
        const [isOpen, setIsOpen] = useState(false);
        const {t}= useTranslation();
  return (
    <>
    <tr
    className="bg-white rounded-[12px]"
    style={{ boxShadow: "0px 4px 32px rgba(86, 92, 120, 0.08)" }}>
        <td className="p-3 min-w-[150px] text-Black font-normal text-justify">
        {formatNumber(owner.id)}
        </td>
        <td className="p-3 min-w-[180px] text-Black font-normal text-justify">
        {formatPhoneNumber(owner.phone)}
        </td>
        <td className="p-3 min-w-[180px] text-Black font-normal text-justify">
        {owner.name}
        </td>
        <td className="p-3 min-w-[180px] text-Black font-normal text-justify">
        {owner.city}
        </td>

        <td className="p-3 min-w-[250px] text-Black font-normal text-justify">
        {owner.email}
        </td>

        <PermissionGate permissions={[PermissionsKey.UpdateOwner]}>
            <td className="p-3 min-w-[150px] text-Black font-normal text-justify">
            <button onClick={()=>setIsOpen(p=>!p)}>
                <Edit/>
            </button>
            </td>
        </PermissionGate>
        <td className="p-3 min-w-[100px] text-Black font-normal text-justify capitalize underline">
            <Link to={`/admin/owners/${owner.id}`}>{t('view')}</Link>
        </td>
    </tr>
        <CustomModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={t('update_information')}
        >
        <UpdateOwnerFormByAdmin
            defaultValues={{
            city:owner.city??"",
            email:owner.email??"",
            name:owner.name??""
        }}
        id={owner.id}
        onSubmitSuccess={() => {
            setIsOpen(p=>false);
  }}
        />
        </CustomModal>
    </>
  )
}

export default OwnerItem